import { Component, type ErrorInfo, type ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';

interface PageErrorBoundaryProps {
  children: ReactNode;
  description: string;
  reference: string;
  retryLabel: string;
  title: string;
}

interface PageErrorBoundaryState {
  hasError: boolean;
}

class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  state: PageErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): PageErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Aura page render failed', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="aura-page-error" role="alert">
        <div className="aura-page-error__inner">
          <p className="aura-page-error__mark">{this.props.reference}</p>
          <h1>{this.props.title}</h1>
          <p>{this.props.description}</p>
          <button type="button" onClick={() => window.location.reload()}>
            <RefreshCw aria-hidden="true" />
            {this.props.retryLabel}
          </button>
        </div>
      </main>
    );
  }
}

export default PageErrorBoundary;
